import jQuery from 'jquery';

import { Foundation } from 'foundation-sites/dist/js/plugins/foundation.core';

// import { Accordion } from 'foundation-sites/dist/js/plugins/foundation.accordion';
// import { ImageLoader } from 'foundation-sites/dist/js/plugins/foundation.util.imageLoader';
// import { Interchange } from 'foundation-sites/dist/js/plugins/foundation.Interchange';
// import { Keyboard } from 'foundation-sites/dist/js/plugins/foundation.util.keyboard';
// import { MediaQuery } from 'foundation-sites/dist/js/plugins/foundation.util.mediaQuery';
// import { Motion } from 'foundation-sites/dist/js/plugins/foundation.util.motion';
import { OffCanvas } from 'foundation-sites/dist/js/plugins/foundation.offcanvas';
// import { ResponsiveAccordionTabs } from 'foundation-sites/dist/js/plugins/foundation.responsiveAccordionTabs';
// import { SmoothScroll } from 'foundation-sites/dist/js/plugins/foundation.smoothScroll';
// import { Sticky } from 'foundation-sites/dist/js/plugins/foundation.sticky';
// import { Reveal } from 'foundation-sites/dist/js/plugins/foundation.reveal';
// import { Tabs } from 'foundation-sites/dist/js/plugins/foundation.tabs';
// import { Touch } from 'foundation-sites/dist/js/plugins/foundation.util.touch';
// import { Triggers } from 'foundation-sites/dist/js/plugins/foundation.util.triggers';

Foundation.addToJquery(jQuery);

// Foundation.plugin(Accordion, 'Accordion');
// Foundation.plugin(ImageLoader, 'ImageLoader');
// Foundation.plugin(Interchange, 'Interchange');
// Foundation.plugin(Keyboard, 'Keyboard');
// Foundation.plugin(MediaQuery, 'MediaQuery');
// Foundation.plugin(Motion, 'Motion');
Foundation.plugin(OffCanvas, 'OffCanvas');
// Foundation.plugin(ResponsiveAccordionTabs, 'ResponsiveAccordionTabs');
// Foundation.plugin(SmoothScroll, 'SmoothScroll');
// Foundation.plugin(Sticky, 'Sticky');
// Foundation.plugin(Reveal, 'Reveal');
// Foundation.plugin(Tabs, 'Tabs');
// Foundation.plugin(Touch, 'Touch');
// Foundation.plugin(Triggers, 'Triggers');

jQuery(($) => {
    $(document).foundation();
});
